import { Skeleton, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";

const FilterBarTab = styled((props) => (
    <Tab {...props} disableRipple />
))(
    ({ theme }) => ({
        padding: theme.spacing(1),
        fontSize: "small",
        fontWeight: 600,
        fontFamily: "inter",
        "& .MuiTabs-indicator": { display: "none" },
    })
);

const FilterBarContainer = styled((props) => (
    <Tabs
        variant="scrollable"
        textColor="secondary"
        indicatorColor="secondary"
        scrollButtons
        allowScrollButtonsMobile
        {...props}
    />
))({
    position: "relative",
    "& .MuiTabs-scrollButtons.Mui-disabled": {
        opacity: 0.3,
    },
    // for safari (otherwise scrollbar will take up some space)
    width: "100%",
    boxShadow: "0 0.6rem 0.6rem -0.6rem #aaaaaa",
    backgroundColor: "#fff",
});

export default function FilterBar(props) {
    const { value, onChange } = props;
    const [filters, setFilters] = useState([...Array(15)]);

    useEffect(() => {
        const getFilters = async () => {
            fetch("https://raw.githubusercontent.com/ruh010/locedge-db/master/filters.json")
                .then((data) => data.json())
                .then((resp) => setFilters(resp));
        }
        getFilters();
    }, []);

    return (
        <FilterBarContainer value={value} onChange={onChange}>
            {filters.map((ft, idx) => (
                <FilterBarTab
                    key={idx}
                    label={ft ? `${ft.name} · ${ft.count}` : <Skeleton variant="text" width="100%" height="100%" />}
                    value={ft ? ft.name : idx || "All"}
                />
            ))}
        </FilterBarContainer>
    );
};